"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const certifications = [{
  id: 1,
  name: "Locally Owned",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1635001/img/certification_gmp_logo.png"
}, {
  id: 2,
  name: "Fully Insured",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1635001/img/certification_fda_logo.png"
}, {
  id: 3,
  name: "5-Star Rated",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1635001/img/certification_iso_logo.png"
}, {
  id: 4,
  name: "Eco-Friendly",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1635001/img/certification_gmp_logo.png"
}, {
  id: 5,
  name: "Same-Day Available",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1635001/img/certification_fda_logo.png"
}];
export default function CertifiedQualityStandards() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223186" id="local-trust-bar" className="bg-card text-foreground py-16 md:py-24 overflow-hidden shadow-xl rounded-2xl">
      <div ref={ref} className={`container mx-auto px-4 flex flex-col items-center justify-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <p className="font-default uppercase text-xs md:text-sm tracking-widest text-chart-1 mb-10 text-center font-bold">
          Locally Owned • Fully Insured • 5-Star Rated • Eco-Friendly • Same-Day Available
        </p>

        <div className="flex flex-wrap justify-center items-center gap-12 md:gap-24 lg:gap-32 w-full max-w-5xl">
          {certifications.map((cert, i) => <div key={cert.id} data-index={i} className="group relative flex items-center justify-center">
              {}
              <div className="absolute inset-0 bg-chart-1/10 blur-2xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              
              <img src={cert.img} alt={cert.name} className="h-12 md:h-16 lg:h-20 w-auto object-contain grayscale-0 opacity-100 transition-all duration-500 ease-in-out group-hover:scale-110 group-hover:drop-shadow-[0_0_12px_var(--chart-1)] relative z-10" />
            </div>)}
        </div>
      </div>
    </section>;
}